<template>
  <footer id="footer" class="main-color mt-5 mt-sm-0 text-light text-center p-3">
    <span>{{this.config.copyright}}</span>
  </footer>
</template>
<script>
export default {
  name: 'CustomerFooter',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomerFooter.vue